document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawer) {
    cartDrawer.allowOutsideClickForTarget = function (target) {
      return target.closest('.rebuy-widget-container') !== null;
    };
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Fix images inserted by Shopper Approved
  const saImages = document.querySelectorAll('img.SA__play');

  saImages.forEach(function (img) {
    if (!img.hasAttribute('alt') || img.alt.trim() === '') {
      img.setAttribute('alt', 'Open image'); // Or 'Star rating' if it's for stars
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
const $$ = (selector, attribute, value) => {
    const interval = setInterval(() => {
        const elems = document.querySelectorAll(selector)
        elems.forEach((elem) => {
            if (value) {
                if (!elem.hasAttribute(attribute)) {
                    elem.setAttribute(attribute, value)
                    clearInterval(interval)
                }
            } else {
                elem.removeAttribute(attribute)
                clearInterval(interval)
            }
        })
    }, 100)
}
$$(".g-recaptcha-response", "title", "ReCaptcha Text Box")
});
